export default "__VITE_ASSET__BQBHNaXL__"